import type { SituacaoConvite } from '@triade/contracts';
import { cn } from '@/lib/utils';
import { ROTULO_SITUACAO_CONVITE, ROTULO_SITUACAO_USUARIO, type SituacaoUsuario } from './tipos';

const BASE = 'inline-flex items-center rounded-full px-2.5 py-0.5 text-caption font-medium';

export function SituacaoUsuarioBadge({ situacao }: { situacao: SituacaoUsuario }) {
  const cor = situacao === 'ATIVO' ? 'bg-success-bg text-success-ink' : situacao === 'INATIVO' ? 'bg-line-soft text-ink-muted' : 'bg-warning-bg text-warning-ink';
  return (
    <span data-testid="situacao-usuario" className={cn(BASE, cor)}>
      {ROTULO_SITUACAO_USUARIO[situacao]}
    </span>
  );
}

export function SituacaoConviteBadge({ situacao }: { situacao: SituacaoConvite }) {
  const cor = situacao === 'PENDENTE' ? 'bg-warning-bg text-warning-ink' : situacao === 'ACEITO' ? 'bg-success-bg text-success-ink' : 'bg-line-soft text-ink-muted';
  return (
    <span data-testid="situacao-convite" className={cn(BASE, cor)}>
      {ROTULO_SITUACAO_CONVITE[situacao]}
    </span>
  );
}
